import { connect } from 'react-redux';
import { FormOwnProps } from 'shared/connect/connect';
import { StreamingUnderlying } from 'state/quotes/streaming/streaming.model';
import { getStreamingUnderlying } from 'state/quotes/streaming/streaming.selector';
import { AppState } from 'state/state.model';

interface StateProps {
  underlying?: StreamingUnderlying;
}
const mapStateToProps = (state: AppState, { formId }: FormOwnProps) => ({
  underlying: getStreamingUnderlying(state, formId),
});

function Underlying({ underlying }: StateProps) {
  return (
    <div>
      {underlying?.code} {underlying?.referencePrice} {underlying?.currency}
    </div>
  );
}

export const ConnectedUnderlying = connect(mapStateToProps)(Underlying);
